<template>
  <div class="field-regexp-robot" v-loading="initLoading" ref="fieldRegexpRobotRef">
    <div class="field-regexp-robot-header">
      <div class="field-regexp-robot-tips">
        <span>请从案件中划词选中文本新增原文或从右侧按钮 [添加划词原文] 添加</span>
      </div>
      <div class="field-regexp-robot-tools">
        <el-popover
          ref="createPopoverRef"
          placement="bottom"
          title=""
          width="300"
          trigger="click"
          @after-leave="createText = ''"
        >
          <el-button type="text" slot="reference">
            <i class="el-icon-plus"></i>
            <span>添加划词原文</span>
          </el-button>
          <div :style="{ padding: '14px' }">
            <el-input v-model="createText" placeholder="请输入需要添加的文本" />
            <div :style="{ textAlign: 'right', marginTop: '14px' }">
              <el-button @click="$refs.createPopoverRef.doClose()">
                <span>取消</span>
              </el-button>
              <el-button type="primary" @click="() => ($refs.createPopoverRef.doClose(), addTextHandle(createText))">
                <span>确认</span>
              </el-button>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
    <el-table :data="regInfoArr" border :resizable="false">
      <el-table-column width="30" align="center">
        <div :style="{ whiteSpace: 'nowrap', marginTop: '5px' }" slot-scope="{ $index }">{{ $index + 1 }}</div>
      </el-table-column>
      <el-table-column label="划词原文">
        <div class="table-td-content text-content" slot-scope="{ row, $index }">
          <el-dropdown @command="type => changeRegexpTypeHandle(row, type)" placement="top">
            <div class="field-regexp-type-picker" :class="`field-regexp-type-${row.type || ''}`">
              <span>{{ typeLabelEnum[row.type] || '-' }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="typeItem in typeOptions" :key="typeItem.type" :command="typeItem.type">
                <span>{{ typeItem.label }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span>
            <span v-for="(textItem, textIdx) in tableTextArr[$index]" :key="`${textItem.text}_${textIdx}`">
              <span
                data-regexp-tag="1"
                :data-sign="`${$index}/${textItem.start}`"
                :data-tag-type="textItem.tagType"
                :class="textItem.tagType && `text-tag-${textItem.tagType}`"
                >{{ textItem.text }}</span
              >
              <i
                class="iconfont iconcha text-tag-del-btn"
                v-if="textItem.tagType"
                @click="delTagHandle(textItem, row)"
              ></i>
            </span>
          </span>
        </div>
      </el-table-column>
      <el-table-column label="标注段落" width="160">
        <div class="table-td-content" slot-scope="{ row }">
          <el-cascader
            class="field-regexp-paragraph-select"
            v-model="row.paragraphArr"
            :options="paragraphTree"
            placeholder="全文"
            clearable
            collapse-tags
            :show-all-levels="false"
            :props="{
              expandTrigger: 'click',
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              value: 'key',
              label: 'value'
            }"
            @change="val => changeSelectParagraphHandle(val, row)"
          />
        </div>
      </el-table-column>
      <el-table-column label="正则表达式" width="160">
        <div class="table-td-content text-content" slot-scope="{ row }">
          <span @click="e => tapRegSymbol(e, row)" v-html="regFormatter(row.reg)"></span>
        </div>
      </el-table-column>
      <el-table-column label="操作" width="50">
        <el-button slot-scope="{ $index }" type="text" @click="delRegInfoHandle($index)">
          <span>删除</span>
        </el-button>
      </el-table-column>
    </el-table>

    <div class="popover-content" :style="popoverContentStyle">
      <el-popover
        ref="popoverRef"
        placement="bottom"
        :width="popoverWidth"
        trigger="click"
        @show="popoverShow = true"
        @hide="popoverShow = false"
      >
        <div v-if="popoverShow" class="tag-type-picker" ref="tagTypePickerRef">
          <template v-for="tagTypeItem in tagTypeOptions">
            <div
              class="tag-type-option"
              :key="tagTypeItem.tagType"
              v-if="(tagTypeItem.children || []).length < 1"
              @click="addTagHandle(tagTypeItem)"
            >
              <span>{{ tagTypeItem.label }}</span>
            </div>
            <el-popover v-else :key="tagTypeItem.tagType" placement="right" title="" width="200" trigger="hover">
              <div class="tag-type-option" slot="reference" @click="addTagHandle(tagTypeItem)">
                <span>{{ tagTypeItem.label }}</span>
              </div>
              <div class="tag-type-dict-content">
                <fieldDictLazyList
                  ref="fieldDictLazyListRef"
                  :defaultDictValue="tagTypeItem.children"
                  @tap="dictItem => addTagHandle(tagTypeItem, { dictItem })"
                />
              </div>
            </el-popover>
          </template>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { cloneDeep, sortBy } from 'lodash';
import { services } from '@/service';
import { arrayToTree, splitType } from '@/lib/utils';
import fieldDictLazyList from '@/components/fieldDictLazyList';
import reporter from '@/lib/reporter';

export default {
  components: { fieldDictLazyList },
  data() {
    return {
      regInfoArr: [],
      initLoading: false,
      paragraphTree: [],
      popoverContentStyle: { top: 0, left: 0 },
      tagPickerModal: {
        regexpIndex: -1,
        textStart: 0,
        selectionStr: '',
        anchorOffset: 0,
        focusOffset: 0
      },
      popoverShow: false,
      createText: '',
      preSelectParagraphArrIdsMap: new WeakMap()
    };
  },
  props: {
    courseId: {
      type: String,
      required: true
    },
    formInfo: {
      type: Object,
      required: true
    },
    defaultSelectTextArr: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    popoverWidth() {
      return 160;
    },
    typeOptions() {
      return [
        { type: 1, label: '正确表述' },
        { type: 2, label: '排除表述' },
        { type: 3, label: '排除句子' }
      ];
    },
    typeLabelEnum() {
      const info = {};
      this.typeOptions.forEach(o => {
        info[o.type] = o.label;
      });
      return info;
    },
    tagTypeOptions() {
      const { regexpIndex } = this.tagPickerModal;
      // const options = [{ tagType: 'keyword', label: '包含关键词' }];
      const options = [];

      if (this.regInfoArr[regexpIndex].type === 1) {
        const fieldType = this.formInfo.type;
        const fieldTypeMaster = fieldType.split('_')[0];

        if (fieldTypeMaster === 'text') {
          const textOption = { tagType: 'normal', label: '抽取文本' };

          if (fieldType === 'text_dict') {
            textOption.children = Object.freeze(this.formInfo.dictClassifyValue);
          }

          options.push(textOption);
        }

        if (fieldTypeMaster === 'num') {
          options.push({ tagType: 'normal', label: '抽取数值' });
        }
        if (fieldTypeMaster === 'date') {
          options.push({ tagType: 'normal', label: '抽取日期' });
        }

        options.push({ tagType: 'invalid', label: '无效文本' });
      } else {
        options.push({ tagType: 'invalid', label: '无效文本' });
      }

      return options;
    },
    tableTextArr() {
      return this.regInfoArr.map(row => this.formatTextArr(row.text, row.tags));
    },
    matchAllRegSymbolTemp() {
      return '【!!all!】';
    }
  },
  watch: {
    regInfoArr: {
      handler(val) {
        this.$emit('change', val);
      },
      deep: true
    }
  },
  beforeDestroy() {
    window.document.removeEventListener('mouseup', this.checkSelectionHandle);
  },
  created() {
    if ((this.formInfo.regInfoArr || []).length > 0) {
      this.regInfoArr = cloneDeep(this.formInfo.regInfoArr);
      this.regInfoArr.forEach(row => {
        if ((row.paragraphArr || []).length > 0) {
          this.preSelectParagraphArrIdsMap.set(row, [...row.paragraphArr]);
        }
      });
    } else {
      this.defaultSelectTextArr.forEach(({ selectText = '', paragraphKey = '' }) => {
        selectText && this.addTextHandle(selectText, paragraphKey);
      });
    }
  },
  async mounted() {
    this.initLoading = true;
    window.document.addEventListener('mouseup', this.checkSelectionHandle);
    const paragraphArr = await services.labelRelation.getParagraph(this.courseId);
    this.paragraphTree = arrayToTree(paragraphArr, { key: 'key', parentKey: 'levelId' }).filter(item => {
      return item.key !== 'para_content';
    });
    this.initLoading = false;
  },
  methods: {
    // 给父级用来清理句子数组
    clearHandle() {
      this.regInfoArr = [];
    },
    delRegInfoHandle(index) {
      this.regInfoArr.splice(index, 1);
    },
    delTagHandle(textItem, row) {
      const idx = row.tags.findIndex(tagItem => {
        return tagItem.start === textItem.start && tagItem.tagType === textItem.tagType;
      });
      if (idx > -1) {
        row.tags.splice(idx, 1);
        this.transformReg(row);
      }
    },
    changeSelectParagraphHandle(val, row) {
      const preSelectParagraphArrIds = this.preSelectParagraphArrIdsMap.get(row) || [];
      const addNew = val.filter(id => !preSelectParagraphArrIds.includes(id));
      const allChildIds = [];
      this.paragraphTree.forEach(item => {
        if (addNew.includes(item.key)) {
          (item.children || []).forEach(subItem => allChildIds.push(subItem.key));
        }
      });

      row.paragraphArr = [...new Set([...row.paragraphArr, ...allChildIds])];
      this.preSelectParagraphArrIdsMap.set(row, [...row.paragraphArr]);
    },
    changeRegexpTypeHandle(row, type) {
      row.type = type;
      row.tags = [];
      this.transformReg(row);
    },
    addTextHandle(text = '', paragraphKey = '') {
      text = text.replace(/(\n\d+\n)|(\n\d+)|(^\d+\n)/g, '').trim();
      if (!text) {
        return;
      }

      const newItem = {
        type: 1,
        paragraphArr: paragraphKey ? [paragraphKey] : [],
        reg: '',
        text,
        tags: []
      };

      this.regInfoArr.push(newItem);
      this.initTagsHandle(newItem);
    },
    async initTagsHandle(item) {
      const NUM_REG = /[两一壹二贰貮三叁四肆五伍六陆七柒八捌九玖零十拾〇万萬亿億千仟百佰\d,，，,.]+/g;
      const DATE_REG = /([一二两三四五六七八九零十〇○Ο０0oO\d]+年([一二两三四五六七八九零十〇○Ο０0oO\d]+月)?([一二两三四五六七八九零十〇○Ο０0oO\d]+[日天])?)|([一二两三四五六七八九零十〇○Ο０0oO\d]+月([一二两三四五六七八九零十〇○Ο０0oO\d]+[日天])?)|([一二两三四五六七八九零十〇○Ο０0oO\d]+[日天])/g;
      try {
        let { type = '', numClassifyUnit = [] } = this.formInfo;
        let normalMatchReg = null;
        let invalidMatchRegArr = [];

        if (type === 'text_dict') {
          let matchTextArr = [];
          (this.formInfo.dictClassifyValue || []).forEach(dictItem => {
            if (!dictItem.labelName) {
              return;
            }
            const childTextArr = (dictItem.children || '')
              .split('|')
              .map(text => text.trim())
              .filter(text => !!text);
            matchTextArr.push(dictItem.labelName, ...childTextArr);
          });
          if (matchTextArr.length > 0) {
            matchTextArr = [...new Set(matchTextArr)];
            normalMatchReg = new RegExp(matchTextArr.join('|'), 'g');
          }
        }

        if (['text', 'text_dict'].includes(type)) {
          invalidMatchRegArr = [DATE_REG, NUM_REG];
        }

        if (type.slice(0, 3) === 'num') {
          normalMatchReg = NUM_REG;
        }

        if (type === 'date') {
          normalMatchReg = DATE_REG;
        }

        if (normalMatchReg) {
          // 数值标签需要初始化单位用于检测
          let checkUnitArr = [];
          if (type.slice(0, 3) === 'num') {
            if (type !== 'num' && numClassifyUnit.length < 1) {
              const sysFieldUnitEnum = await services.courseware.getSysFieldUnit();
              numClassifyUnit = sysFieldUnitEnum[splitType(this.formInfo.type).deputyFieldType] || [];
            }
            numClassifyUnit.forEach(unitItem => {
              checkUnitArr.push(unitItem.unit);
              (unitItem.reg || '').split('|').forEach(regText => {
                checkUnitArr.push(regText);
              });
            });
            checkUnitArr = [...new Set(checkUnitArr.filter(t => !!t))];
          }
          const checkUnit = checkUnitArr.length > 0;

          // 挖空有效标签
          const matchArr = [...item.text.matchAll(normalMatchReg)];
          (matchArr || []).forEach(matchItem => {
            const tagEnd = matchItem.index + matchItem[0].length;

            if (checkUnit) {
              const matchUnitIdx = checkUnitArr.findIndex(unitText => {
                return item.text.slice(tagEnd, tagEnd + unitText.length) === unitText;
              });
              if (matchUnitIdx === -1) {
                return;
              }
            }

            item.tags.push({
              start: matchItem.index,
              end: tagEnd,
              tagType: 'normal'
            });
          });
        }

        // 挖空无效标签
        invalidMatchRegArr.forEach(invalidReg => {
          const invalidMatchArr = [...item.text.matchAll(invalidReg)];
          (invalidMatchArr || []).forEach(matchItem => {
            const newInvalidTag = {
              start: matchItem.index,
              end: matchItem.index + matchItem[0].length,
              tagType: 'invalid'
            };
            const isExists = this.checkTagsExists(item.tags, newInvalidTag);
            !isExists && item.tags.push(newInvalidTag);
          });
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.transformReg(item);
      }
    },
    checkTagsExists(tags, compareTagItem) {
      const idx = tags.findIndex(tagItem => {
        if (compareTagItem.start >= tagItem.start && compareTagItem.start <= tagItem.end) {
          return true;
        }
        if (compareTagItem.end >= tagItem.start && compareTagItem.end <= tagItem.end) {
          return true;
        }
        if (compareTagItem.start < tagItem.start && compareTagItem.end > tagItem.end) {
          return true;
        }
        return false;
      });
      return idx > -1;
    },
    transformReg(item) {
      try {
        // 合并类型相同并相邻的tag
        const tags = this.mergeSameTagHandle(item.tags);

        let textArr = this.formatTextArr(item.text, tags);

        if (textArr[0].tagType === 'invalid') {
          textArr.shift();
        }
        if (textArr[textArr.length - 1].tagType === 'invalid') {
          textArr.pop();
        }

        if (textArr.length === 1) {
          const textItem = textArr[0];
          if (!textItem.tagType || ['keyword', 'normal'].includes(textItem.tagType)) {
            item.reg = textItem.text;
          } else {
            item.reg = '';
          }
          return;
        }

        // 存在【包含关键词】的话移除前后无效的文本，非无效则替换成 \\S*?
        const haveKeywordTag = textArr.some(textItem => textItem.tagType === 'keyword');
        if (haveKeywordTag) {
          const firstTextTagIdx = textArr.findIndex(textItem => textItem.tagType && textItem.tagType !== 'invalid');
          const firstTextTagItem = textArr[firstTextTagIdx];
          if (firstTextTagItem.tagType === 'keyword') {
            textArr = textArr.slice(firstTextTagIdx);
          } else {
            textArr = [
              { tagType: firstTextTagItem.tagType, text: this.matchAllRegSymbolTemp },
              ...textArr.slice(firstTextTagIdx + 1)
            ];
          }

          let lastTextTagIdx = [...textArr]
            .reverse()
            .findIndex(textItem => textItem.tagType && textItem.tagType !== 'invalid');
          lastTextTagIdx = textArr.length - lastTextTagIdx - 1;
          const lastTextTagItem = textArr[lastTextTagIdx];
          if (lastTextTagItem.tagType === 'keyword') {
            textArr = textArr.slice(0, lastTextTagIdx + 1);

            // 数值标签特殊处理，只有一个keyword时，则在后面添加 \S*
            if (this.formInfo.type.slice(0, 3) === 'num' && textArr.length === 1 && textArr[0].end < item.text.length) {
              textArr.push({ tagType: 'normal', text: this.matchAllRegSymbolTemp });
            }
          } else {
            textArr = [
              ...textArr.slice(0, lastTextTagIdx),
              { tagType: lastTextTagItem.tagType, text: this.matchAllRegSymbolTemp }
            ];
          }
        }

        // 将非关键词的替换为 \\S*?
        textArr.forEach(textItem => {
          if (['normal', 'invalid'].includes(textItem.tagType) || (haveKeywordTag && !textItem.tagType)) {
            textItem.text = this.matchAllRegSymbolTemp;
          }
        });
        // 替换后将相邻的 \\S*? 合并为一个
        let preInvalidTextItem = null;
        textArr = textArr.filter(textItem => {
          if (
            preInvalidTextItem &&
            preInvalidTextItem.text === this.matchAllRegSymbolTemp &&
            textItem.text === this.matchAllRegSymbolTemp
          ) {
            if (textItem.tagType === 'normal') {
              preInvalidTextItem.tagType = 'normal';
            }
            return false;
          }

          preInvalidTextItem = textItem;
          return true;
        });

        // 判断数值标签是否需要正则分组处理，有多个关键词则需要分组，非数值标签直接合并文本段落的text即为正则
        let numGroupReg = false;
        if (this.formInfo.type.slice(0, 3) === 'num') {
          let keywordTagCount = 0;
          let haveNormalTag = false;
          textArr.forEach(textItem => {
            if (textItem.tagType === 'normal') {
              haveNormalTag = true;
            }
            if (textItem.tagType === 'keyword') {
              keywordTagCount++;
            }
          });
          numGroupReg = keywordTagCount > 1 && haveNormalTag;
        }
        if (numGroupReg) {
          const newTextArr = [];
          textArr.forEach((textItem, textIdx) => {
            if (textItem.tagType !== 'keyword') {
              return;
            }
            if (textIdx === textArr.length - 1) {
              newTextArr.push({ text: `${this.matchAllRegSymbolTemp}${textItem.text}` });
            } else {
              newTextArr.push({ text: `${textItem.text}${this.matchAllRegSymbolTemp}` });
            }
          });
          if (newTextArr.length === 1) {
            item.reg = this.fixRegSymbol(newTextArr[0].text);
          } else {
            item.reg = newTextArr.map(textItem => `(${this.fixRegSymbol(textItem.text)})`).join('|');
          }
        } else {
          item.reg = textArr.map(textItem => textItem.text).join('');
          item.reg = this.fixRegSymbol(item.reg);
        }
        new RegExp(item.reg);
      } catch (err) {
        reporter.log({ message: `原句：${item.text}，异常正则：${item.reg}`, code: '智推正则转换异常' });
        item.reg = item.text;
      }
    },
    fixRegSymbol(reg) {
      let newReg = reg;

      const specialSymbolStr = ['[', ']', '\\', '^', '$', '.', '|', '?', '*', '+', '(', ')']
        .map(s => `\\${s}`)
        .join('|');
      newReg = newReg.replace(new RegExp(specialSymbolStr, 'g'), s => `\\${s}`);

      newReg = newReg.replace(new RegExp(this.matchAllRegSymbolTemp, 'g'), '\\S*?');

      // 最后如果是 \S*? 则删除 ?
      if (newReg.slice(-'\\S*?'.length) === '\\S*?') {
        newReg = newReg.slice(0, -1);
      }

      return newReg;
    },
    mergeSameTagHandle(tags) {
      const newTags = [];
      let lastNewTagItem = null;
      sortBy(tags || [], ['start', 'end']).forEach(tagItem => {
        if (lastNewTagItem && lastNewTagItem.tagType === tagItem.tagType && lastNewTagItem.end >= tagItem.start) {
          lastNewTagItem.end = tagItem.end;
          return;
        }

        lastNewTagItem = { ...tagItem };
        newTags.push(lastNewTagItem);
      });
      return newTags;
    },
    formatTextArr(text, tags) {
      const textArr = [{ text, start: 0, end: text.length, tagType: '' }];
      sortBy(tags || [], ['start', 'end']).forEach(tagItem => {
        const idx = textArr.findIndex(textItem => {
          return tagItem.start >= textItem.start && tagItem.end <= textItem.end;
        });
        if (idx === -1) {
          return;
        }
        const textItem = textArr[idx];
        if (textItem.tagType) {
          return;
        }
        let preTextItem = null;
        let newTagTextItem = null;
        let lastTextItem = null;
        if (textItem.start < tagItem.start) {
          preTextItem = {
            text: textItem.text.slice(0, tagItem.start - textItem.start),
            start: textItem.start,
            end: tagItem.start,
            tagType: ''
          };
        }
        newTagTextItem = {
          ...tagItem,
          text: textItem.text.slice(tagItem.start - textItem.start, tagItem.end - textItem.start)
        };
        if (textItem.end > tagItem.end) {
          lastTextItem = {
            text: textItem.text.slice(tagItem.end - textItem.start),
            start: tagItem.end,
            end: textItem.end,
            tagType: ''
          };
        }
        const replaceArr = [preTextItem, newTagTextItem, lastTextItem].filter(o => !!o);
        textArr.splice(idx, 1, ...replaceArr);
      });
      return textArr;
    },
    addTagHandle(tagTypeItem, params = {}) {
      const { dictItem } = params;
      const { regexpIndex, textStart, anchorOffset, focusOffset, selectionStr } = this.tagPickerModal;

      this.regInfoArr[regexpIndex].tags.push({
        start: textStart + (anchorOffset < focusOffset ? anchorOffset : focusOffset),
        end: textStart + (anchorOffset > focusOffset ? anchorOffset : focusOffset),
        tagType: tagTypeItem.tagType
      });

      if (this.formInfo.type === 'text_dict' && selectionStr && tagTypeItem.tagType === 'normal') {
        this.$emit('updDict', { text: selectionStr, dictItem });
      }

      this.$refs.popoverRef.doClose();

      this.transformReg(this.regInfoArr[regexpIndex]);
    },
    checkSelectionHandle(e) {
      if (this.$refs.tagTypePickerRef) {
        let close = false;
        if (!this.$refs.tagTypePickerRef.contains(e.target)) {
          close = true;
        }
        if (close && this.$refs.fieldDictLazyListRef) {
          const ref = this.$refs.fieldDictLazyListRef[0];
          if (ref && ref.$el.contains(e.target)) {
            close = false;
          }
        }
        if (close) {
          this.$refs.popoverRef.doClose();
        }
      }

      const { button } = e;
      const selection = window.document.getSelection();
      const { isCollapsed, anchorNode, focusNode, anchorOffset, focusOffset } = selection;
      const selectionStr = selection.toString();

      if (isCollapsed || button !== 0 || !selectionStr) {
        return;
      }

      if (
        !anchorNode.parentNode ||
        !focusNode.parentNode ||
        !anchorNode.parentNode.dataset.regexpTag ||
        !anchorNode.parentNode.dataset.sign ||
        anchorNode.parentNode.dataset.sign !== focusNode.parentNode.dataset.sign ||
        anchorNode.parentNode.dataset.tagType
      ) {
        return;
      }

      const [regexpIndex, textStart] = anchorNode.parentNode.dataset.sign.split('/').map(num => Number(num));

      this.tagPickerModal = {
        regexpIndex,
        textStart,
        selectionStr,
        anchorOffset,
        focusOffset
      };

      this.initPopoverContentStyle(e);
      this.$nextTick(() => {
        if (this.$refs.popoverRef.showPopper) {
          return;
        }
        this.$refs.popoverRef.doShow();
      });
    },
    initPopoverContentStyle(e) {
      const editorRefPosition = this.$refs.fieldRegexpRobotRef.getBoundingClientRect();
      const top = e.y - this.tagTypeOptions.length * 32;
      let left = e.x;

      const outsideX = e.x + this.popoverWidth + 40 - editorRefPosition.right;
      if (outsideX > 0) {
        left -= outsideX;
      }

      this.popoverContentStyle = { top: `${top}px`, left: `${left}px` };
    },
    regFormatter(regText = '') {
      return regText.replace(/\\S\*\??/g, (t, offset) => {
        return `<span class="match-symbol" data-offset="${offset}">${t}</span>`;
      });
    },
    tapRegSymbol(e, row) {
      if (!e.target.dataset.offset) {
        return;
      }
      const offset = Number(e.target.dataset.offset);
      const curSymbol = e.target.innerHTML;
      const replaceSymbol = curSymbol === '\\S*?' ? '\\S*' : '\\S*?';
      row.reg = `${row.reg.slice(0, offset)}${replaceSymbol}${row.reg.slice(offset + curSymbol.length)}`;
    }
  }
};
</script>

<style lang="scss">
.tag-type-picker {
  .tag-type-option {
    font-size: 14px;
    line-height: 32px;
    cursor: pointer;
    padding: 0 20px;

    &:hover {
      background-color: #eaf6ff;
    }
  }
}
.tag-type-dict-content {
  .field-dict-li {
    cursor: pointer;

    &:hover {
      background-color: #eaf6ff;
    }
  }
}
</style>
<style lang="scss" scoped>
.popover-content {
  position: fixed;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  overflow: visible;
  z-index: 10;
}
.field-regexp-robot {
  .field-regexp-robot-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
    .field-regexp-robot-tips {
      font-size: 12px;
      color: #9599a5;
    }
    .field-regexp-robot-tools {
    }
  }
  ::v-deep .el-table {
    .el-table__header-wrapper {
      .el-table__cell {
        background: #f8fafd;
      }
    }
    .el-table__body-wrapper {
      .el-table__body {
        tr:hover > td.el-table__cell {
          background: #fff;
        }
      }
      .el-table__cell {
        vertical-align: top;
      }
    }
  }

  ::v-deep .field-regexp-paragraph-select {
    width: 100%;
    /* .el-input__inner {
      border: 0;
    } */
  }

  .table-td-content {
    color: #3d465a;
    font-size: 14px;
    line-height: 22px;
    word-break: break-all;

    &.text-content {
      margin: 5px 0;

      ::v-deep .match-symbol {
        color: #1991fb;
        cursor: pointer;
      }
    }

    .text-tag-keyword {
      color: #04c838;
    }

    .text-tag-normal {
      text-decoration: underline;
    }

    .text-tag-invalid {
      color: #9599a5;
      text-decoration: line-through;
    }

    .text-tag-del-btn {
      user-select: none;
      cursor: pointer;
      font-size: 12px;
      color: #9599a5;
      background-color: #fff;
      border-radius: 50%;
    }

    .field-regexp-type-picker {
      display: inline-block;
      line-height: 22px;
      font-size: 12px;
      padding: 0 4px;
      border-radius: 2px;
      cursor: pointer;
      margin-right: 4px;
      &.field-regexp-type-1 {
        color: #1991fb;
        background-color: rgba(#1991fb, 0.1);
      }
      &.field-regexp-type-2 {
        color: #ee813b;
        background-color: rgba(#ee813b, 0.1);
      }
      &.field-regexp-type-3 {
        color: #e42626;
        background-color: rgba(#e42626, 0.1);
      }
    }
  }
}
</style>
